module.exports = __webpack_public_path__ + "static/media/bitbucket.75331a23.png";